import React from 'react'

import { MainStyle } from './Main.styles'

export const Main = ({ children, ...props }) => (
  <MainStyle as="main" {...props}>
    {children}
  </MainStyle>
)
